import styled, { createGlobalStyle, keyframes } from "styled-components";
import { gridConfig } from "@tvg/fuse-responsive-grid";

const fadeIn = keyframes`
  from {
    opacity: 0.3;
  }
  to {
    opacity: 1;
  }
`;

export const StyledOverlay = styled.div`
  visibility: visible;
  position: fixed;
  inset: 0;
  z-index: 100;
  overflow-y: auto;
  animation: ${fadeIn} 400ms;

  @media screen and (min-width: ${gridConfig.l.minWidth}) {
    height: 50%;
    height: fit-content;
    overflow-y: unset;
    background-color: unset;
  }
`;

export const StyledPopup = styled.div<{ $hasBackground?: boolean }>`
  position: relative;
  margin: 0;
  width: 100%;
  min-height: 100%;
  background-color: var(--color-base-white);

  @media screen and (min-width: ${gridConfig.l.minWidth}) {
    padding-right: var(--complex-header-scrollbar-width);
  }
`;

export const StyledModalBackdrop = styled.div`
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  background: var(--color-base-black, #000000);
  height: 100%;
  width: 100%;
  opacity: 0.25;
  z-index: 10;

  @media screen and (min-width: ${gridConfig.l.minWidth}) {
    display: block;
  }
`;

export const StyledModal = styled.div`
  position: relative;
  height: 0%;
  border-radius: 10px;
  margin: 0 auto;
`;

export const GlobalStyle = createGlobalStyle`
	:root {
	  overflow-y: hidden;
    padding-right: var(--complex-header-scrollbar-width);
	}
`;
